/** The Opening screen's title and its one-time backfill hook, kept apart from the screen so Today can use them without loading it. */
import { useEffect, useRef } from "react";
import { clearLegacyPhase, loadLegacyPhase } from "./opening.ts";
import { useApi, useSession } from "../session.tsx";

export const OPENING_TITLE = "Open legally and stay inspection-ready";

/**
 * The backfill (A8, migration 0065): a browser that still holds the old per-device answer copies it to the location once,
 * when an owner or admin opens the app and the location has no answer yet. Then the local copy is cleared.
 */
export function usePhaseBackfill() {
  const api = useApi();
  const s = useSession();
  const tried = useRef(false);
  useEffect(() => {
    if (tried.current || s.location.openingPhase || !s.can("admin")) return;
    const legacy = loadLegacyPhase(s.org.id);
    if (!legacy) return;
    tried.current = true;
    api.updateLocation(s.org.id, s.location.id, { openingPhase: legacy })
      .then((loc) => { clearLegacyPhase(s.org.id); s.patchLocation(loc); })
      .catch(() => { /* kept locally; tried again next visit */ tried.current = false; });
  }, [api, s]);
}
